/**
 * Forward-geocode a free-text address (Nominatim). Returns { latitude, longitude, label } or null.
 * Tries a couple of query shapes because full house-level strings often miss in OSM.
 */
export async function forwardGeocodeAddress(query) {
  const q = String(query || "").trim();
  if (!q) return null;

  async function search(params) {
    try {
      const url = `https://nominatim.openstreetmap.org/search?${params.toString()}`;
      const res = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      });
      if (!res.ok) return null;
      const json = await res.json();
      const hit = Array.isArray(json) ? json[0] : null;
      if (!hit) return null;
      const latitude = Number(hit.lat);
      const longitude = Number(hit.lon);
      if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return null;
      return {
        latitude,
        longitude,
        label: String(hit.display_name || q).trim() || q,
      };
    } catch {
      return null;
    }
  }

  const primary = new URLSearchParams({
    format: "jsonv2",
    limit: "1",
    countrycodes: "in",
    q,
  });
  const first = await search(primary);
  if (first) return first;

  // Retry without country filter (some localities resolve better).
  const retry = new URLSearchParams({
    format: "jsonv2",
    limit: "1",
    q: q.toLowerCase().includes("india") ? q : `${q}, India`,
  });
  return search(retry);
}
